var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"74cd58e7844a252ce95163e376d85e5ad2a47029"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prebuilt-ui@pluot-communications"]={id:"74cd58e7844a252ce95163e376d85e5ad2a47029"};
      